import SouthEastIcon from '@mui/icons-material/SouthEast';

export const webTypes = [
    {id: Math.random(), type: "web", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "webLanding", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "webCorporate", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "webShop", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "webUiUx", arrow: <SouthEastIcon/>},
    {id: Math.random(), type: "webSupport", arrow: <SouthEastIcon/>}
]